import React, { useEffect, useState } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { compose } from 'redux';
import { Provider } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import moment from 'moment';

import { multibonusRestHooks } from '../../../store/Multibonus/MultibonusSlice';
import store from '../../../store';
import { ElementLink } from '../../../components';
import { taskSchedulesRestHooks } from '../../../store/TaskSchedules/TaskSchedulesSlice';

import BonusCell from './BonusCell';

require('moment-timezone');

function ScheduleBonusList() {
  const {
    updateTaskSchedule,
    deleteTaskSchedule,
    loadTaskSchedules,
    loadResetTaskSchedules,
    taskSchedules: { loadingStatus, items: taskSchedules },
  } = taskSchedulesRestHooks.use();

  useEffect(() => {
    loadTaskSchedules('bonus');
    return () => {
      loadResetTaskSchedules();
    };
  }, []);

  const handleEdit = async (id, params) => {
    await updateTaskSchedule(id, params);
    loadTaskSchedules('bonus');
  };

  const handleDelete = async (id) => {
    await deleteTaskSchedule(id);
    loadTaskSchedules('bonus');
  };

  return (
    <div className="messages">
      <div className="header">
        <h2>Bonuses</h2>
        <div className="actions">
          <Link to="/multibonus/new" className="button">
            New Bonus
          </Link>
        </div>
      </div>

      <div className="scroll-container">
        <div className="tabs">
          <NavLink to="/multibonus" activeClassName="active">
            Scheduled
          </NavLink>
        </div>

        <table className="tables">
          <thead>
            <tr>
              <th>Title</th>
              <th>Execution Time</th>
              <th>Number Of Users</th>
              <th>Title Message</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {taskSchedules.map((item) => (
              <BonusCell
                item={item}
                handleEdit={handleEdit}
                handleDelete={handleDelete}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const addStore = (ProxyComponent) => (props) =>
  (
    <Provider store={store}>
      <ProxyComponent {...props} />
    </Provider>
  );

export default compose(addStore)(ScheduleBonusList);
